import { useState } from 'react';

const faqs = [
    {
        q: "Do I need special hardware or scanners?",
        a: "No. StockEasy works entirely on iOS and Android smartphones. Your team uses the camera they already have in their pocket.",
    },
    {
        q: "What if a part doesn't have a barcode?",
        a: "No problem — our AI scanner can also read plain labels, and part numbers directly, without needing a barcode.",
    },
    {
        q: "How long does onboarding take?",
        a: "Most customers are fully set up within 5–10 minutes. We walk you through everything during the free demo call and provide documentation.",
    },
    {
        q: "Is my data secure?",
        a: "Yes. All data is encrypted in transit and at rest. We do not share your data with third parties. You can request deletion at any time.",
    },
    {
        q: "Can I cancel at any time?",
        a: "Absolutely. There are no lock-in contracts. Cancel your subscription at any time from your account settings with no penalty.",
    },
];

const FaqSection = () => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);

    return (
        <section id="faq" className="py-20 bg-blue-50">
            <div className="container mx-auto px-4">
                <div className="text-center mb-14">
                    <span className="text-blue-600 font-semibold text-sm uppercase tracking-widest">Common Questions</span>
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2">Frequently Asked Questions</h2>
                </div>

                <div className="max-w-3xl mx-auto space-y-4">
                    {faqs.map((faq, i) => (
                        <div key={i} className="bg-white rounded-xl shadow-sm overflow-hidden">
                            <button
                                onClick={() => toggle(i)}
                                className="w-full flex justify-between items-center px-6 py-5 text-left font-semibold text-gray-800 hover:bg-gray-50 transition"
                            >
                                <span>{faq.q}</span>
                                <i
                                    className="fas fa-chevron-down text-blue-600 transition-transform duration-200"
                                    style={{ transform: openIndex === i ? 'rotate(180deg)' : 'rotate(0deg)' }}
                                ></i>
                            </button>
                            {openIndex === i && (
                                <div className="px-6 pb-5 text-gray-500 text-sm">
                                    {faq.a}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FaqSection;
